import { defineMessages } from 'react-intl'

export default defineMessages({
  history: {
    id: 'containers.CustomerOrdersPage.components.components.OrderHistory.history',
    defaultMessage: 'History',
  },
  alert: {
    id: 'containers.CustomerOrdersPage.components.components.OrderHistory.alert',
    defaultMessage: 'Message can not be empty.',
  },
  send: {
    id: 'containers.CustomerOrdersPage.components.components.OrderHistory.send',
    defaultMessage: 'Send',
  },
  typeMessage: {
    id: 'containers.CustomerOrdersPage.components.components.OrderHistory.typeMessage',
    defaultMessage: 'Type message...',
  },
})
